/**
 * EmptyState - Displayed when user has no organization
 */
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Building2, ArrowRight } from "lucide-react";

export default function EmptyState() {
  const navigate = useNavigate();
  
  return (
    <div className="text-center py-20" data-testid="org-empty-state">
      <Building2 className="w-16 h-16 mx-auto text-muted-foreground/40 mb-6" />
      <h2 className="font-heading text-2xl font-semibold mb-2">
        No Organization Yet
      </h2>
      <p className="text-muted-foreground max-w-md mx-auto mb-8">
        Organization plans let your team share access under one account. Contact
        our sales team to get started.
      </p>
      <Button
        onClick={() => navigate("/contact-sales?plan_key=organization")}
        className="btn-lift"
        data-testid="contact-sales-btn"
      >
        Contact Sales
        <ArrowRight className="w-4 h-4 ml-2" />
      </Button>
    </div>
  );
}
